import React, { useState } from "react";
import { useParams } from "react-router-dom";

const Create = () => {
  const { type } = useParams();

  // State for form data
  const [formData, setFormData] = useState({
    companyName: "",
    fullName: "",
    companySize: "",
    location: "",
    hrTools: "",
    platform: "",
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    referralSource: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData); // Replace with API call later
  };

  return (
    <div className="flex justify-center items-center min-h-screen text-black">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-xl font-semibold text-center mb-4">Create Account</h2>

        <form className="space-y-4" onSubmit={handleSubmit}>
          {type === "recruiter" ? (
            <>
              <div>
                <label className="block text-sm font-medium">
                  Company Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  placeholder="Enter your company name"
                  className="mt-1 w-full p-2 border rounded-md focus:ring focus:ring-blue-300 placeholder:text-gray-400"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                  className="mt-1 w-full p-2 border rounded-md focus:ring focus:ring-blue-300 placeholder:text-gray-400"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium">
                  Company Size <span className="text-red-500">*</span>
                </label>
                <select
                  name="companySize"
                  value={formData.companySize}
                  onChange={handleChange}
                  className="mt-1 w-full p-2 border rounded-md focus:ring focus:ring-blue-300"
                  required
                >
                  <option value="">Select your company size</option>
                  <option value="startup">Startup</option>
                  <option value="small">Small</option>
                  <option value="medium">Medium</option>
                  <option value="large">Large</option>
                  <option value="enterprise">Enterprise</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium">
                  Location <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder="Enter company location"
                  className="mt-1 w-full p-2 border rounded-md focus:ring focus:ring-blue-300"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium">
                  Do you use any existing ATS/CRM tools? <span className="text-red-500">*</span>
                </label>
                <div className="flex items-center space-x-4 mt-1">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="hrTools"
                      value="yes"
                      checked={formData.hrTools === "yes"}
                      onChange={handleChange}
                      className="mr-2"
                    />
                    Yes
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="hrTools"
                      value="no"
                      checked={formData.hrTools === "no"}
                      onChange={handleChange}
                      className="mr-2"
                    />
                    No
                  </label>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium">
                  Platform <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="platform"
                  value={formData.platform}
                  onChange={handleChange}
                  placeholder="Enter your Platform"
                  className="mt-1 w-full p-2 border rounded-md focus:ring focus:ring-blue-300 placeholder:text-gray-400"
                  required
                />
              </div>
            </>
          ) : type === "candidate" ? (
            <>
              <div>
                <label className="block text-sm font-medium">
                  First Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="Enter your first name"
                  className="mt-1 w-full p-2 border rounded-md focus:ring focus:ring-blue-300"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium">
                  Last Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Enter your last name"
                  className="mt-1 w-full p-2 border rounded-md focus:ring focus:ring-blue-300"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  className="mt-1 w-full p-2 border rounded-md focus:ring focus:ring-blue-300"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium">
                  Contact Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="contactNumber"
                  value={formData.contactNumber}
                  onChange={handleChange}
                  placeholder="Enter your contact number"
                  className="mt-1 w-full p-2 border rounded-md focus:ring focus:ring-blue-300"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium">
                  How did you hear about us? <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="referralSource"
                  value={formData.referralSource}
                  onChange={handleChange}
                  placeholder="Let us know how you found us"
                  className="mt-1 w-full p-2 border rounded-md focus:ring focus:ring-blue-300"
                  required
                />
              </div>
            </>
          ) : (
            <p className="text-red-500 text-center">Invalid form type.</p>
          )}

          <button
            type="submit"
            className="w-full bg-teal-600 text-white py-2 mt-4 rounded-md hover:bg-teal-700 transition"
          >
            Create account
          </button>
        </form>
      </div>
    </div>
  );
};

export default Create;
